import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { BioVerifyComponent } from 'src/app/shared/bio-verify.component';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-liveness',
  templateUrl: './liveness.component.html',
  styleUrls: ['./liveness.component.css']
})
export class LivenessComponent extends BioVerifyComponent implements OnInit {

  public showVideoElement = false;
  public isLoading = false;
  public blobUrl: any;

  get isSupportedBrowser(): boolean {
    const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    return isSafari === false;
  }

  private verificationId = '';
  private invitationId = '';
  private captchaToken: string;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    super();
  }

  ngOnInit() {
    this.invitationId = this.route.snapshot.paramMap.get('invitationId');
    this.verificationId = this.route.snapshot.paramMap.get('verificationId');
  }

  public async resolved(captchaResponse: string) {
    try {
      this.captchaToken = captchaResponse;
      this.isLoading = true;
      const base64Data = await this.loadVideoData();
      const videoBlob = this.b64toBlob(base64Data, 'video/mp4');
      const url = URL.createObjectURL(videoBlob);
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(url);
      this.showVideoElement = true;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
    }
  }

  private loadVideoData(): Promise<string> {
    const url = `${environment.bioverifyApiURL}/v1/video/${this.verificationId}?invitationId=${this.invitationId}&token=${this.captchaToken}`;;
    console.log(`Calling ${url}`);
    return this.http.get(url, ).pipe(map(response => {
      return response as string;
    })).toPromise();
  }

  private b64toBlob(b64Data: string, contentType: string = '', sliceSize: number = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
